import en from "./en";
import ua from "./ua";
export default {
    en:en,
    ua:ua
}
